import React from "react";
import { Box, Container, Grid, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { changeView, clearCalculators } from "../calculators/calculatorsSlice";

export const Home = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const calculators = useSelector(state => state.calculators.schema);

	const nav = (key) => {
		dispatch(clearCalculators());
		const { path } = calculators[key];
		const view = path.slice(1);
		navigate(path);
		dispatch(changeView(view));
		window.scrollTo(0, 0);
	};

	return (
		<Box sx={{pb: 1, minHeight: 500}}>
			{/*<Box sx={{*/}
			{/*	height: 400, width: "100%",*/}
			{/*	overflow: "hidden",*/}
			{/*	backgroundImage: "url(./img/banner.png)",*/}
			{/*	backgroundSize: "cover",*/}
			{/*	backgroundPosition: "center"*/}
			{/*}}>*/}
			{/*	<Box sx={{*/}
			{/*		height: 400, width: "100%",*/}
			{/*		backgroundImage: "url(./img/yktp.png)",*/}
			{/*		backgroundPosition: "center"*/}
			{/*	}} />*/}
			{/*</Box>*/}
			<Box sx={{
				mb: 7,
				"& .MuiTypography-root": {
					fontFamily: "'Raleway', 'Helvetica', 'Arial', sans-serif"
				}
			}}>
				<Box sx={{py: 3, maxWidth: 750, m: "0 auto"}}>
					<Box sx={{pt: "56.25%", position: "relative", width: "100%"}}>
						<iframe
							className="iframe sproutvideo-player"
							src="https://videos.sproutvideo.com/embed/ac9fdab61613e6c625/2ec2bd401098983a?bigPlayButton=false&amp;playerTheme=dark&amp;playerColor=2f3437"
							width="640"
							height="360"
							frameBorder="0"
							allowFullScreen
							referrerPolicy="no-referrer-when-downgrade"
							title="Video Player"
						/>					</Box>
				</Box>
				<Box sx={{bgcolor: "#e5e3db", pt: 6, pb: 7, display: "flex", alignItems: "center", flexDirection: "column"}}>
					<Typography variant="h4" gutterBottom sx={{color: "#E26811"}}><b>Let's get started!</b></Typography>
					<Typography variant="h6"><b>Select one of the calculators below to begin.</b></Typography>
				</Box>
			</Box>
			<Container maxWidth="lg" sx={{maxWidth: "1600px !important"}}>
				<Box sx={{pb: 3}}>
					<Grid container spacing={2} alignItems="stretch" justifyContent="center" direction="row">
						{calculators.map(({ label, description, path }, key) =>
							<Grid key={`home_item_${key}`} item xs={12} md={6} lg={3}>
								<Button
									variant="contained"
									color="secondary"
									sx={{height: "100%", width: "100%", borderRadius: 2, p: 0, border: "1px solid", borderColor: "secondary.dark", overflow: "hidden"}}
									onClick={() => nav(key)}
								>
									<Box sx={{height: "100%", display: "flex", flexDirection: "column"}}>
										<Typography variant="button" sx={{p: 2, display: "block"}}>{label}</Typography>
										<Box sx={{alignItems: "center", bgcolor: "common.white", color: "text.primary", height: "100%", p: 2, display: "flex"}}>
											<Typography sx={{textTransform: "initial"}} variant="body1"><i>{description}</i></Typography>
										</Box>
									</Box>
								</Button>
							</Grid>
						)}
					</Grid>
				</Box>
			</Container>
		</Box>
	);
};
